// extracted by css-extract-rspack-plugin
export default {"trigger":"trigger-x6bMF7","errorText":"errorText-Iuv7Ai"};